import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=0fcfbf59&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./styles/dashboard-styles.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=0fcfbf59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcfbf59",
  null
  
)

export default component.exports